//-------------------------------------------------------------------
// If not valid combination returns lang code, as international version
//-------------------------------------------------------------------
export const getValidLocaleCode = (langCode, countryCode) => {
  const validCodes = [
    "ar",
    "ar-AE",
    "ar-BH",
    "ar-DJ",
    "ar-DZ",
    "ar-EG",
    "ar-EH",
    "ar-ER",
    "ar-IL",
    "ar-IQ",
    "ar-IQ",
    "ar-JO",
    "ar-JO",
    "ar-KM",
    "ar-KW",
    "ar-LB",
    "ar-LY",
    "ar-MA",
    "ar-MR",
    "ar-OM",
    "ar-PS",
    "ar-QA",
    "ar-SA",
    "ar-SD",
    "ar-SO",
    "ar-SS",
    "ar-SY",
    "ar-TD",
    "ar-TN",
    "ar-YE",
    "as",
    "as-IN",
    "asa",
    "asa-TZ",
    "az",
    "az-Cyrl",
    "az-Cyrl-AZ",
    "az-Latn",
    "az-Latn-AZ",
    "bas",
    "bas-CM",
    "be",
    "be-BY",
    "bem",
    "bem-ZM",
    "bez",
    "bez-TZ",
    "bg",
    "bg-BG",
    "bm",
    "bm-ML",
    "bn",
    "bn",
    "bn-BD",
    "bn-IN",
    "bo",
    "bo-CN",
    "bo-IN",
    "br",
    "br-FR",
    "brx",
    "brx-IN",
    "bs",
    "bs-Cyrl",
    "bs-Cyrl-BA",
    "bs-Latn",
    "bs-Latn-BA",
    "ca",
    "ca-AD",
    "ca-ES",
    "ca-FR",
    "ca-IT",
    "ce",
    "ce-RU",
    "cgg",
    "cgg-UG",
    "chr",
    "chr-US",
    "cs",
    "cs-CZ",
    "cy",
    "cy-GB",
    "da",
    "da-DK",
    "dav",
    "dav-KE",
    "de",
    "de-AT",
    "de-BE",
    "de-CH",
    "de-DE",
    "de-IT",
    "de-LI",
    "de-LU",
    "dje",
    "dje-NE",
    "dsb",
    "dsb-DE",
    "dua",
    "dua-CM",
    "dyo",
    "dyo-SN",
    "dz",
    "dz-BT",
    "ebu",
    "ebu-KE",
    "ee",
    "ee-GH",
    "ee-TG",
    "el",
    "el-CY",
    "el-GR",
    "en",
    "en-AG",
    "en-AI",
    "en-AS",
    "en-AT",
    "en-AU",
    "en-BB",
    "en-BE",
    "en-BI",
    "en-BM",
    "en-BS",
    "en-BW",
    "en-BZ",
    "en-CA",
    "en-CC",
    "en-CH",
    "en-CK",
    "en-CM",
    "en-CX",
    "en-CY",
    "en-DE",
    "en-DG",
    "en-DK",
    "en-DM",
    "en-ER",
    "en-FI",
    "en-FJ",
    "en-FK",
    "en-FM",
    "en-GB",
    "en-GD",
    "en-GG",
    "en-GH",
    "en-GI",
    "en-GM",
    "en-GU",
    "en-GY",
    "en-HK",
    "en-IE",
    "en-IL",
    "en-IM",
    "en-IN",
    "en-IO",
    "en-JE",
    "en-JM",
    "en-KE",
    "en-KI",
    "en-KN",
    "en-KY",
    "en-LC",
    "en-LR",
    "en-LS",
    "en-MG",
    "en-MH",
    "en-MO",
    "en-MP",
    "en-MS",
    "en-MT",
    "en-MU",
    "en-MW",
    "en-MY",
    "ne-NP",
    "en-NA",
    "en-NF",
    "en-NG",
    "en-NL",
    "en-NR",
    "en-NU",
    "en-NZ",
    "en-PG",
    "en-PH",
    "en-PK",
    "en-PN",
    "en-PR",
    "en-PW",
    "en-RW",
    "en-SB",
    "en-SC",
    "en-SD",
    "en-SE",
    "en-SG",
    "en-SH",
    "en-SI",
    "en-SL",
    "en-SS",
    "en-SX",
    "en-SZ",
    "en-TC",
    "en-TK",
    "en-TO",
    "en-TT",
    "en-TV",
    "en-TZ",
    "en-UG",
    "en-UM",
    "en-US",
    "en-VC",
    "en-VG",
    "en-VI",
    "en-VU",
    "en-WS",
    "en-ZA",
    "en-ZM",
    "en-ZW",
    "eo",
    "es",
    "es-AR",
    "es-BO",
    "es-BR",
    "es-BZ",
    "es-CL",
    "es-CO",
    "es-CR",
    "es-CU",
    "es-DO",
    "es-EA",
    "es-EC",
    "es-ES",
    "es-GQ",
    "es-GT",
    "es-HN",
    "es-IC",
    "es-MX",
    "es-NI",
    "es-PA",
    "es-PE",
    "es-PR",
    "es-PY",
    "es-SV",
    "es-US",
    "es-UY",
    "es-VE",
    "et",
    "et-EE",
    "eu",
    "eu-ES",
    "ewo",
    "ewo-CM",
    "fa",
    "fa-AF",
    "fa-IR",
    "ff-CM",
    "ps-AF",
    "ff",
    "ff-GN",
    "ff-MR",
    "ff-SN",
    "fi",
    "fi-FI",
    "fil",
    "fil-PH",
    "fo",
    "fo-DK",
    "fo-FO",
    "fr",
    "fr-BE",
    "fr-BF",
    "fr-BI",
    "fr-BJ",
    "fr-BL",
    "fr-CA",
    "fr-CD",
    "fr-CF",
    "fr-CG",
    "fr-CH",
    "fr-CI",
    "fr-CM",
    "fr-DJ",
    "fr-DZ",
    "fr-FR",
    "fr-GA",
    "fr-GF",
    "fr-GN",
    "fr-GP",
    "fr-GQ",
    "fr-HT",
    "fr-KM",
    "fr-LU",
    "fr-MA",
    "fr-MC",
    "fr-MF",
    "fr-MG",
    "fr-ML",
    "fr-MQ",
    "fr-MR",
    "fr-MU",
    "fr-NC",
    "fr-NE",
    "fr-PF",
    "fr-PM",
    "fr-RE",
    "fr-RW",
    "fr-SC",
    "fr-SN",
    "fr-SY",
    "fr-TD",
    "fr-TG",
    "fr-TN",
    "fr-VU",
    "fr-WF",
    "fr-YT",
    "fur",
    "fur-IT",
    "fy",
    "fy-NL",
    "ga",
    "ga",
    "ga-IE",
    "ga-IE",
    "gd",
    "gd-GB",
    "gl",
    "gl-ES",
    "gsw",
    "gsw-CH",
    "gsw-FR",
    "gsw-LI",
    "gu",
    "gu-IN",
    "guz",
    "guz-KE",
    "gv",
    "gv-IM",
    "ha",
    "ha-GH",
    "ha-NE",
    "ha-NG",
    "haw",
    "haw-US",
    "he",
    "he-IL",
    "hi",
    "hi-IN",
    "hr",
    "hr-BA",
    "hr-HR",
    "hsb",
    "hsb-DE",
    "hu",
    "hu-HU",
    "hy",
    "hy-AM",
    "ig",
    "ig-NG",
    "ii",
    "ii-CN",
    "id",
    "id-ID",
    "is",
    "is-IS",
    "it",
    "it-CH",
    "it-IT",
    "it-SM",
    "it-VA",
    "iw",
    "iw-IL",
    "ja",
    "ja-JP",
    "jgo",
    "jgo-CM",
    "jmc",
    "jmc-TZ",
    "ka",
    "ka-GE",
    "kab",
    "kab-DZ",
    "kam",
    "kam-KE",
    "kde",
    "kde-TZ",
    "kea",
    "ml-IN",
    "kea-CV",
    "khq",
    "khq-ML",
    "ki",
    "ki-KE",
    "kk",
    "kk-KZ",
    "kkj",
    "kkj-CM",
    "kl",
    "kl-GL",
    "kln",
    "kln-KE",
    "km",
    "km-KH",
    "kn",
    "kn-IN",
    "ko",
    "ko",
    "ko-KP",
    "ko-KR",
    "kok",
    "kok-IN",
    "ks",
    "ks-IN",
    "ksb",
    "ksb-TZ",
    "ksf",
    "ksf-CM",
    "ksh",
    "ksh-DE",
    "kw",
    "kw-GB",
    "ky",
    "ky-KG",
    "lag",
    "lag-TZ",
    "lt",
    "lt-LT",
    "lb",
    "lb-LU",
    "lv",
    "lv-LV",
    "lg",
    "lg-UG",
    "mk",
    "mk-MK",
    "ms",
    "ms-MY",
    "mt",
    "mt-MT",
    "nl",
    "nl-BE",
    "nl-NL",
    "no",
    "no-NO",
    "no-NO-NY",
    "pl",
    "pl-PL",
    "pt",
    "pt-AO",
    "pt-BR",
    "pt-CH",
    "pt-CV",
    "pt-GQ",
    "pt-GW",
    "pt-LU",
    "pt-MO",
    "pt-MZ",
    "pt-PT",
    "pt-ST",
    "pt-TL",
    "ro",
    "ro-RO",
    "ru",
    "ru-BY",
    "ru-KG",
    "ru-KZ",
    "ru-MD",
    "ru-RU",
    "ru-UA",
    "sk",
    "sk-SK",
    "sl",
    "prs-AF",
    "sl-SI",
    "sq",
    "sq-AL",
    "sr",
    "sr-BA",
    "sr-CS",
    "sr-ME",
    "sr-RS",
    "sv",
    "sv-SE",
    "th",
    "th-TH",
    "th-TH-TH",
    "tr",
    "tr-TR",
    "uk",
    "uk-UA",
    "vi",
    "vi-VN",
    "uz",
    "uz-UZ",
    "uz-UZ",
    "uz-AF",
    "zh",
    "zh-Hans",
    "zh-Hans-HK",
    "zh-Hans-MO",
    "zh-Hans-SG",
    "zh-Hant",
    "zh-Hant-HK",
    "zh-Hant-MO",
    "zh-Hant-TW",
    "zh-HK",
    "zu",
    "zu-ZA",
  ]

  const idealLocale = `${langCode.toLowerCase()}-${countryCode.toUpperCase()}`
  if (validCodes.includes(idealLocale)) return idealLocale
  else return langCode
}

export const WEBSITE_GENERIC_LANGUAGES = ["de", "en", "es"]
